import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Checkbox } from '@/components/ui/checkbox';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { API_BASE } from '@/config/api';
import { setAdminToken } from '@/lib/adminAuth';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('admin');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const { data } = await axios.post(`${API_BASE}/admin/login`, {
        username,
        password,
        remember_me: rememberMe,
      });
      setAdminToken(data.access_token, { persist: rememberMe });
      navigate('/admin/panel', { replace: true });
    } catch (err) {
      const status = err.response?.status;
      if (status === 404) {
        setError(
          'No se encontró la API (404). En Vercel configura MUNIBUS_BACKEND_URL (proxy /api) o REACT_APP_BACKEND_URL en el build del front; en local ejecuta el backend en el puerto 8000 y usa npm start (proxy /api). Comprueba CORS en el backend para el dominio del front.'
        );
        return;
      }
      if (status === 503) {
        const d = err.response?.data?.detail;
        setError(typeof d === 'string' ? d : 'El proxy /api no está disponible (503).');
        return;
      }
      const d = err.response?.data?.detail;
      setError(typeof d === 'string' ? d : 'No se pudo iniciar sesión.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="border-border/60 shadow-ambient">
      <CardHeader>
        <CardTitle className="font-headline text-2xl">Ingreso administrador</CardTitle>
        <CardDescription>
          Credenciales del backend (variables ADMIN_* en Railway).
        </CardDescription>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="admin-user">Usuario</Label>
            <Input
              id="admin-user"
              name="username"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="admin-pass">Contraseña</Label>
            <Input
              id="admin-pass"
              name="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="flex items-center gap-2">
            <Checkbox
              id="admin-remember"
              checked={rememberMe}
              onCheckedChange={(v) => setRememberMe(v === true)}
            />
            <Label htmlFor="admin-remember" className="text-sm font-normal leading-none">
              Recordarme en este dispositivo
            </Label>
          </div>
          {error && <p className="text-sm text-destructive">{error}</p>}
          <Button type="submit" className="w-full touch-target" disabled={loading}>
            {loading ? 'Ingresando…' : 'Ingresar'}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
}
